import { ErrorBoundary } from '@components/error-boundary';
import { ModulesEnum } from '@/types/enums/filials';
import { useAppSelector } from '@/hooks/redux/redux';
import CommonModuleContainer from '@/containers/pages/filials/edit/components/common/modules';

const EmailModule = () => {
  const { filial } = useAppSelector((state) => state.filials);

  return (
    <ErrorBoundary componentTitle="Email module page">
      <CommonModuleContainer filial={filial} currentModule={ModulesEnum.Mail} />
    </ErrorBoundary>
  );
};

export default EmailModule;
